var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Input, Select, message } from 'antd';
import { ArrowRightOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import services from 'services';
import EmptyComponent from 'components/EmptyComponent';
import Loader from 'components/AntEnhancement/Loader';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { FilterIcon } from 'assets/icons';
import { Appointments as AppointmentResource } from 'constants/resources';
import NewAppointmentDrawer from './NewAppointmentDrawer';
import './style.css';
var csvEscape = function (value) {
    var text = value.replace(/"/g, '""');
    return "\"".concat(text, "\"");
};
var downloadCsv = function (filename, rows) {
    var content = rows.map(function (row) { return row.map(csvEscape).join(','); }).join('\n');
    var blob = new Blob(["\uFEFF".concat(content)], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};
var PAGE_SIZE = 25;
var STATUS_OPTIONS = [
    'all',
    'waiting',
    'confirmed',
    'in_visit',
    'finished',
    'cancelled'
];
var statusTone = {
    pending: 'is-pending',
    un_reached: 'is-unreached',
    confirmed: 'is-confirmed',
    waiting: 'is-waiting',
    in_visit: 'is-invisit',
    after_work: 'is-afterwork',
    finished: 'is-finished',
    cancelled: 'is-cancelled',
    postponed: 'is-postponed'
};
var formatSlot = function (appointment) {
    var _a;
    var when = appointment.getAppointmentTime();
    if (!((_a = when === null || when === void 0 ? void 0 : when.isValid) === null || _a === void 0 ? void 0 : _a.call(when))) {
        return { date: '—', time: '—' };
    }
    return {
        date: when.format('DD/MM/YYYY'),
        time: when.format('hh:mm A')
    };
};
var Appointments = function (props) {
    var _a, _b, _c;
    var t = props.translate;
    var navigate = useNavigate();
    var _d = useState(1), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = useState('patient_phone_number'), searchKey = _e[0], setSearchKey = _e[1];
    var _f = useState(''), searchValue = _f[0], setSearchValue = _f[1];
    var _g = useState('all'), statusFilter = _g[0], setStatusFilter = _g[1];
    var _h = useState(false), showNewDrawer = _h[0], setShowNewDrawer = _h[1];
    var _j = useState(false), exporting = _j[0], setExporting = _j[1];
    var debounceTimeOut;
    var filters = useMemo(function () {
        var next = {};
        if (searchValue)
            next[searchKey] = searchValue;
        if (statusFilter !== 'all')
            next.status = statusFilter;
        return next;
    }, [searchKey, searchValue, statusFilter]);
    var appointmentService = services.appointmentService, permissionService = services.permissionService;
    var _k = appointmentService.useAppointments(pageNumber, filters), data = _k.data, isLoading = _k.isLoading, isFetching = _k.isFetching;
    var canAddAppointment = permissionService.hasPermissionToAdd(AppointmentResource);
    var canShowAppointment = permissionService.hasPermissionToShow(AppointmentResource);
    var appointments = (data === null || data === void 0 ? void 0 : data.appointments) || [];
    var meta = data === null || data === void 0 ? void 0 : data.meta;
    var totalCount = Number((_a = meta === null || meta === void 0 ? void 0 : meta.count) !== null && _a !== void 0 ? _a : 0);
    var pagesCount = (meta === null || meta === void 0 ? void 0 : meta.getPagesCount()) || 0;
    var from = Number((_b = meta === null || meta === void 0 ? void 0 : meta.from) !== null && _b !== void 0 ? _b : (appointments.length ? (pageNumber - 1) * PAGE_SIZE + 1 : 0));
    var to = Number((_c = meta === null || meta === void 0 ? void 0 : meta.to) !== null && _c !== void 0 ? _c : (appointments.length ? from + appointments.length - 1 : 0));
    var searchPlaceholder = useMemo(function () {
        if (searchKey === 'clinic_name')
            return t('header.searchByClinicName');
        return t('header.searchByPatientPhone');
    }, [searchKey, t]);
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceTimeOut);
        debounceTimeOut = setTimeout(function () {
            setPageNumber(1);
            setSearchValue(value);
        }, 500);
    };
    var searchMenu = {
        selectedKeys: [searchKey],
        onClick: function (_a) {
            var key = _a.key;
            setSearchKey(key);
            setPageNumber(1);
        },
        items: [
            { key: 'patient_phone_number', label: t('patientPhone') },
            { key: 'clinic_name', label: t('clinicName') }
        ]
    };
    var openAppointment = function (appointmentId) {
        if (!canShowAppointment)
            return;
        navigate("/appointments/".concat(appointmentId));
    };
    var doctorLabel = function (appointment) {
        var _a, _b;
        var name = (_b = (_a = appointment.getDoctor()) === null || _a === void 0 ? void 0 : _a.getUser()) === null || _b === void 0 ? void 0 : _b.getName();
        return name ? "".concat(t('drPrefix'), " ").concat(name) : '—';
    };
    var exportAppointments = function () { return __awaiter(void 0, void 0, void 0, function () {
        var collected, page, totalPages, pageData, rows, stamp, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (exporting)
                        return [2 /*return*/];
                    setExporting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, 7, 8]);
                    collected = [];
                    page = 1;
                    totalPages = 1;
                    _c.label = 2;
                case 2: return [4 /*yield*/, appointmentService.fetchAppointmentsPage(page, filters)];
                case 3:
                    pageData = _c.sent();
                    collected.push.apply(collected, (pageData.appointments || []));
                    totalPages = Math.max(((_b = pageData.meta) === null || _b === void 0 ? void 0 : _b.getPagesCount()) || 1, 1);
                    page += 1;
                    _c.label = 4;
                case 4:
                    if (page <= totalPages) return [3 /*break*/, 2];
                    _c.label = 5;
                case 5:
                    if (collected.length === 0) {
                        message.warning(t('exportEmpty'));
                        return [2 /*return*/];
                    }
                    rows = __spreadArray([
                        [
                            t('id'),
                            t('colPatient'),
                            t('patientPhone'),
                            t('doctorName'),
                            t('specialization'),
                            t('clinic'),
                            t('colSlot'),
                            t('status')
                        ]
                    ], collected.map(function (appointment) {
                        var _a, _b, _c;
                        var patient = appointment.getPatient();
                        var doctor = appointment.getDoctor();
                        var slot = formatSlot(appointment);
                        return [
                            String(appointment.getId()),
                            (patient === null || patient === void 0 ? void 0 : patient.getName()) || '',
                            (patient === null || patient === void 0 ? void 0 : patient.getPrimaryPhone()) || '',
                            ((_a = doctor === null || doctor === void 0 ? void 0 : doctor.getUser()) === null || _a === void 0 ? void 0 : _a.getName()) || '',
                            ((_b = doctor === null || doctor === void 0 ? void 0 : doctor.getSpecialization()) === null || _b === void 0 ? void 0 : _b.getName()) || '',
                            ((_c = appointment.getClinic()) === null || _c === void 0 ? void 0 : _c.getName()) || '',
                            "".concat(slot.date, " ").concat(slot.time),
                            appointment.getDisplayedStatus() || appointment.getStatus() || ''
                        ];
                    }), true);
                    stamp = new Date().toISOString().slice(0, 10);
                    downloadCsv("appointments-".concat(stamp, ".csv"), rows);
                    return [3 /*break*/, 8];
                case 6:
                    _a = _c.sent();
                    message.error(t('exportFailed'));
                    return [3 /*break*/, 8];
                case 7:
                    setExporting(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "appointments-screen", children: [_jsxs("header", { className: "appointments-heading", children: [_jsxs("div", { className: "appointments-heading__left", children: [_jsxs("div", { className: "appointments-title-row", children: [_jsx("h1", { children: t('title') }), _jsx("span", { className: "appointments-count", children: t('countBadge', { count: totalCount }) })] }), _jsx("p", { className: "appointments-subtitle", children: t('subtitle') })] }), _jsxs("div", { className: "appointments-heading__actions", children: [_jsxs("button", { type: "button", className: "appointments-btn appointments-btn--secondary", onClick: exportAppointments, disabled: exporting, children: [_jsx(UploadOutlined, {}), _jsx("span", { children: exporting ? t('exporting') : t('export') })] }), canAddAppointment && (_jsxs("button", { type: "button", className: "appointments-btn appointments-btn--primary", onClick: function () { return setShowNewDrawer(true); }, children: [_jsx(PlusOutlined, {}), _jsx("span", { children: t('newAppointment') })] }))] })] }), _jsxs("div", { className: "appointments-toolbar", children: [_jsxs("div", { className: "appointments-search", children: [_jsx(SearchOutlined, { className: "appointments-search__icon" }), _jsx(Input, { className: "appointments-search__input", placeholder: searchPlaceholder, onChange: onSearchValueChange, allowClear: true, "aria-label": searchPlaceholder }), _jsx(Dropdown, { menu: searchMenu, trigger: ['click'], children: _jsx("button", { type: "button", className: "appointments-search__filter", "aria-label": t('filters'), children: _jsx(FilterIcon, {}) }) })] }), _jsx(Select, { className: "appointments-status-filter", value: statusFilter, onChange: function (value) {
                            setStatusFilter(value);
                            setPageNumber(1);
                        }, options: STATUS_OPTIONS.map(function (key) { return ({
                            value: key,
                            label: key === 'all' ? t('statusFilter.all') : t("statusFilter.".concat(key))
                        }); }) })] }), _jsxs("section", { className: "appointments-table-card", children: [_jsx(Loader, { renderSpinner: isLoading && !data, className: "appointments-list", children: appointments.length === 0 ? (_jsxs("div", { className: "appointments-empty", children: [_jsx(EmptyComponent, {}), _jsx("p", { children: t('empty') })] })) : (_jsx("div", { className: "appointments-table-scroll", children: _jsxs("div", { className: isFetching ? 'appointments-table is-fetching' : 'appointments-table', role: "table", children: [_jsxs("div", { className: "appointments-table__head", role: "row", children: [_jsx("div", { className: "appointments-cell is-id", role: "columnheader", children: t('id') }), _jsx("div", { className: "appointments-cell is-patient", role: "columnheader", children: t('colPatient') }), _jsx("div", { className: "appointments-cell is-doctor", role: "columnheader", children: t('doctorName') }), _jsx("div", { className: "appointments-cell is-spec", role: "columnheader", children: t('specialization') }), _jsx("div", { className: "appointments-cell is-clinic", role: "columnheader", children: t('clinic') }), _jsx("div", { className: "appointments-cell is-time", role: "columnheader", children: t('colSlot') }), _jsx("div", { className: "appointments-cell is-status", role: "columnheader", children: t('status') }), _jsx("div", { className: "appointments-cell is-action", role: "columnheader", children: t('action') })] }), appointments.map(function (appointment) {
                                        var _a, _b, _c;
                                        var patient = appointment.getPatient();
                                        var slot = formatSlot(appointment);
                                        var statusKey = appointment.getStatus();
                                        var tone = statusTone[statusKey] || 'is-pending';
                                        return (_jsxs("div", { role: "row", className: "appointments-table__row", onClick: function () { return openAppointment(appointment.getId()); }, children: [_jsx("div", { className: "appointments-cell is-id", role: "cell", children: _jsxs("span", { className: "appointments-id", children: ["#", appointment.getId()] }) }), _jsx("div", { className: "appointments-cell is-patient", role: "cell", children: _jsxs("div", { className: "appointments-patient", children: [_jsx("span", { className: "appointments-patient__name", children: (patient === null || patient === void 0 ? void 0 : patient.getName()) || '—' }), _jsx("span", { className: "appointments-patient__phone", children: (patient === null || patient === void 0 ? void 0 : patient.getPrimaryPhone()) || '—' })] }) }), _jsx("div", { className: "appointments-cell is-doctor", role: "cell", children: doctorLabel(appointment) }), _jsx("div", { className: "appointments-cell is-spec", role: "cell", children: _jsx("span", { className: "appointments-chip", children: ((_b = (_a = appointment.getDoctor()) === null || _a === void 0 ? void 0 : _a.getSpecialization()) === null || _b === void 0 ? void 0 : _b.getName()) || '—' }) }), _jsx("div", { className: "appointments-cell is-clinic", role: "cell", children: ((_c = appointment.getClinic()) === null || _c === void 0 ? void 0 : _c.getName()) || '—' }), _jsx("div", { className: "appointments-cell is-time", role: "cell", children: _jsxs("div", { className: "appointments-slot", children: [_jsx("span", { className: "appointments-slot__date", children: slot.date }), _jsx("span", { className: "appointments-slot__time", children: slot.time })] }) }), _jsx("div", { className: "appointments-cell is-status", role: "cell", children: _jsxs("span", { className: "appointments-status ".concat(tone), children: [_jsx("span", { className: "appointments-status__dot", "aria-hidden": true }), appointment.getDisplayedStatus() || statusKey] }) }), _jsx("div", { className: "appointments-cell is-action", role: "cell", children: canShowAppointment ? (_jsxs("button", { type: "button", className: "appointments-row-link", onClick: function (event) {
                                                            event.stopPropagation();
                                                            openAppointment(appointment.getId());
                                                        }, children: [_jsx("span", { children: t('common:buttons.show') }), _jsx(ArrowRightOutlined, {})] })) : null })] }, appointment.getId()));
                                    })] }) })) }), appointments.length > 0 && (_jsxs("div", { className: "appointments-pager", children: [_jsx("div", { className: "appointments-pager__meta", children: t('showingRange', { from: from, to: to, total: totalCount }) }), _jsxs("div", { className: "appointments-pager__controls", children: [_jsx("button", { type: "button", className: "appointments-pager__btn", disabled: pageNumber <= 1, onClick: function () { return setPageNumber(function (page) { return Math.max(1, page - 1); }); }, children: t('previous') }), _jsx("span", { className: "appointments-pager__page", children: t('pageOf', { page: pageNumber, pages: Math.max(pagesCount, 1) }) }), _jsx("button", { type: "button", className: "appointments-pager__btn", disabled: pagesCount > 0 ? pageNumber >= pagesCount : true, onClick: function () { return setPageNumber(function (page) { return page + 1; }); }, children: t('next') })] })] }))] }), _jsx(NewAppointmentDrawer, { open: showNewDrawer, onClose: function () { return setShowNewDrawer(false); } })] }));
};
export default localeTranslator(Appointments, 'appointments');
